import React from 'react';

import { IconProps } from '../../../DefaultIcon';

export function SearchEmployee({ className }: IconProps) {
  return (
    <svg
      width="82"
      height="70"
      viewBox="0 0 82 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4_3867)">
        <path
          d="M49.842 54.4937H23.2598V65.1266H49.842V54.4937Z"
          fill="#EAEEF9"
        />
        <path
          d="M69.3354 56.4873H3.98734C1.77215 56.4873 0 54.7152 0 52.5V3.98734C0 1.77215 1.77215 0 3.98734 0H69.3354C71.5506 0 73.3228 1.77215 73.3228 3.98734V52.5C73.3228 54.7152 71.3291 56.4873 69.3354 56.4873Z"
          fill="#EAEEF9"
        />
        <path
          d="M60.9181 70H12.4055C11.0763 70 9.96875 68.8924 9.96875 67.5633C9.96875 66.2342 11.0763 65.1266 12.4055 65.1266H60.9181C62.2472 65.1266 63.3548 66.2342 63.3548 67.5633C63.1333 68.8924 62.2472 70 60.9181 70Z"
          fill="#EAEEF9"
        />
        <path
          d="M66.234 51.6139H7.0884C5.9808 51.6139 5.09473 50.7278 5.09473 49.6203V7.08861C5.09473 5.98102 5.9808 5.09494 7.0884 5.09494H66.234C67.3416 5.09494 68.2276 5.98102 68.2276 7.08861V49.6203C68.2276 50.7278 67.3416 51.6139 66.234 51.6139Z"
          fill="white"
        />
        <path
          d="M65.5699 29.019H7.75342C7.31039 29.019 7.08887 28.7975 7.08887 28.3544C7.08887 27.9114 7.31039 27.6899 7.75342 27.6899H65.5699C66.0129 27.6899 66.2344 27.9114 66.2344 28.3544C66.2344 28.576 66.0129 29.019 65.5699 29.019Z"
          fill="#00C4B3"
        />
        <path
          d="M36.5503 49.8418C36.1073 49.8418 35.8857 49.6203 35.8857 49.1772V7.31013C35.8857 6.86709 36.1073 6.64557 36.5503 6.64557C36.9933 6.64557 37.2149 6.86709 37.2149 7.31013V49.1772C37.2149 49.6203 36.9933 49.8418 36.5503 49.8418Z"
          fill="#00C4B3"
        />
        <path
          d="M20.6012 16.6139C16.1708 16.6139 12.6265 19.9367 11.9619 24.1456C11.9619 24.8101 12.405 25.2532 12.848 25.2532H28.1328C28.7974 25.2532 29.2404 24.8101 29.0189 24.1456C28.5758 19.9367 25.0315 16.6139 20.6012 16.6139Z"
          fill="#00C4B3"
        />
        <path
          d="M27.2472 11.962C27.2472 15.7278 24.3674 18.6076 20.6016 18.6076C16.8358 18.6076 13.9561 15.7278 13.9561 11.962C13.9561 8.1962 16.8358 5.31645 20.6016 5.31645C24.3674 5.31645 27.2472 8.1962 27.2472 11.962Z"
          fill="white"
        />
        <path
          d="M25.253 11.962C25.253 14.6202 23.2593 16.6139 20.6011 16.6139C17.9429 16.6139 15.9492 14.6202 15.9492 11.962C15.9492 9.30379 17.9429 7.31012 20.6011 7.31012C23.2593 7.31012 25.253 9.30379 25.253 11.962Z"
          fill="#00C4B3"
        />
        <path
          d="M52.4996 16.6139C48.0692 16.6139 44.5249 19.9367 43.8604 24.1456C43.8604 24.8101 44.3034 25.2532 44.7464 25.2532H60.0312C60.6958 25.2532 61.1388 24.8101 60.9173 24.1456C60.6958 19.9367 56.93 16.6139 52.4996 16.6139Z"
          fill="#00416B"
        />
        <path
          d="M59.1456 11.962C59.1456 15.7278 56.2659 18.6076 52.5001 18.6076C48.7342 18.6076 45.8545 15.7278 45.8545 11.962C45.8545 8.1962 48.7342 5.31645 52.5001 5.31645C56.2659 5.31645 59.1456 8.1962 59.1456 11.962Z"
          fill="white"
        />
        <path
          d="M57.1515 11.962C57.1515 14.6202 55.1578 16.6139 52.4996 16.6139C49.8413 16.6139 47.8477 14.6202 47.8477 11.962C47.8477 9.30379 49.8413 7.31012 52.4996 7.31012C55.1578 7.31012 57.1515 9.30379 57.1515 11.962Z"
          fill="#00416B"
        />
        <path
          d="M20.6012 40.3165C16.1708 40.3165 12.6265 43.6392 11.9619 47.8481C11.9619 48.5127 12.405 48.9557 12.848 48.9557H28.1328C28.7974 48.9557 29.2404 48.5127 29.0189 47.8481C28.5758 43.6392 25.0315 40.3165 20.6012 40.3165Z"
          fill="#00416B"
        />
        <path
          d="M27.2472 35.6646C27.2472 39.4304 24.3674 42.3101 20.6016 42.3101C16.8358 42.3101 13.9561 39.4304 13.9561 35.6646C13.9561 31.8987 16.8358 29.019 20.6016 29.019C24.3674 29.019 27.2472 31.8987 27.2472 35.6646Z"
          fill="white"
        />
        <path
          d="M25.253 35.6646C25.253 38.3228 23.2593 40.3165 20.6011 40.3165C17.9429 40.3165 15.9492 38.3228 15.9492 35.6646C15.9492 33.0063 17.9429 31.0127 20.6011 31.0127C23.2593 31.0127 25.253 33.0063 25.253 35.6646Z"
          fill="#00416B"
        />
        <path
          d="M52.4996 40.3165C48.0692 40.3165 44.5249 43.6392 43.8604 47.8481C43.8604 48.5127 44.3034 48.9557 44.7464 48.9557H60.0312C60.6958 48.9557 61.1388 48.5127 60.9173 47.8481C60.6958 43.6392 56.93 40.3165 52.4996 40.3165Z"
          fill="#00C4B3"
        />
        <path
          d="M59.1456 35.6646C59.1456 39.4304 56.2659 42.3101 52.5001 42.3101C48.7342 42.3101 45.8545 39.4304 45.8545 35.6646C45.8545 31.8987 48.7342 29.019 52.5001 29.019C56.2659 29.019 59.1456 31.8987 59.1456 35.6646Z"
          fill="white"
        />
        <path
          d="M57.1515 35.6646C57.1515 38.3228 55.1578 40.3165 52.4996 40.3165C49.8413 40.3165 47.8477 38.3228 47.8477 35.6646C47.8477 33.0063 49.8413 31.0127 52.4996 31.0127C55.1578 31.0127 57.1515 33.0063 57.1515 35.6646Z"
          fill="#00C4B3"
        />
        <path
          d="M78.6389 62.0253C77.7528 62.0253 76.8667 61.8038 76.2022 61.1392L49.6199 34.557C48.2908 33.2278 48.2908 31.0127 49.6199 29.6835C50.949 28.3544 53.1642 28.3544 54.4933 29.6835L81.0756 56.2658C82.4047 57.5949 82.4047 59.8101 81.0756 61.1392C80.1895 61.8038 79.5249 62.0253 78.6389 62.0253Z"
          fill="#00416B"
        />
        <path
          d="M73.9877 34.1139C73.9877 45.1899 65.1269 54.0506 54.051 54.0506C42.975 54.0506 34.1143 45.1899 34.1143 34.1139C34.1143 23.038 42.975 14.1772 54.051 14.1772C64.9054 14.1772 73.9877 23.038 73.9877 34.1139Z"
          fill="#00C4B3"
        />
        <path
          d="M70.0003 34.1139C70.0003 42.9747 62.9117 50.0633 54.0509 50.0633C45.1902 50.0633 38.1016 42.9747 38.1016 34.1139C38.1016 25.2532 45.1902 18.1646 54.0509 18.1646C62.9117 18.1646 70.0003 25.2532 70.0003 34.1139Z"
          fill="#EAEEF9"
        />
        <path
          d="M68.0061 34.1139C68.0061 41.8671 61.8036 48.0696 54.0504 48.0696C46.2973 48.0696 40.0947 41.8671 40.0947 34.1139C40.0947 26.3608 46.2973 20.1582 54.0504 20.1582C61.8036 20.1582 68.0061 26.3608 68.0061 34.1139Z"
          fill="#FBFCFE"
        />
        <path
          d="M54.2721 33.6709C49.8417 33.6709 46.2974 36.9937 45.6328 41.2025C45.6328 41.8671 46.0758 42.3101 46.5189 42.3101H61.8037C62.4683 42.3101 62.9113 41.8671 62.6898 41.2025C62.2467 36.7722 58.7024 33.6709 54.2721 33.6709Z"
          fill="#00C4B3"
        />
        <path
          d="M60.9181 29.019C60.9181 32.7848 58.0383 35.6646 54.2725 35.6646C50.5067 35.6646 47.627 32.7848 47.627 29.019C47.627 25.2532 50.5067 22.3734 54.2725 22.3734C57.8168 22.3734 60.9181 25.2532 60.9181 29.019Z"
          fill="white"
        />
        <path
          d="M58.9239 29.019C58.9239 31.6772 56.9302 33.6709 54.272 33.6709C51.6138 33.6709 49.6201 31.6772 49.6201 29.019C49.6201 26.3608 51.6138 24.3671 54.272 24.3671C56.7087 24.3671 58.9239 26.3608 58.9239 29.019Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_3867">
          <rect width="81.962" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
